<template>
  <div class="news-card overflow-hidden h-48 relative md:m-2 rounded-lg flex-1 min-w-72 m-4 ">
    <a :href="portfolio.url" target="_blank" rel="nofollow"
      class="news-card__card-link absolute top-0 left-0 w-full h-full"></a>
    <img :src="require('@/assets/images/portfolio/'+portfolio.image)" :alt="portfolio.title"
     class="news-card__image relative block w-full h-full object-cover">
    <div class="news-card__text-wrapper w-full absolute bottom-0 text-white p-4">
      <h2 class="news-card__title text-3xl text-shadow-pop-left mb-2">{{portfolio.title}}</h2>
      <div class="news-card__details-wrapper">
        <p class="news-card__excerpt">{{$t(portfolio.description)}}</p>
        <ul class="flex justify-end mt-2">
          <li v-for="(icon, index) of portfolio.icons" :key="index" class="mx-2">
            <font-awesome-icon class="text-4xl" :class="'text-'+icon.name"
            :icon="icon.icon" v-if="icon.isIcon" />
            <img class="h-10" v-else :src="require('@/assets/images/skills/'+icon.image)" alt="">
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PortfolioCard',
  props: {
    portfolio: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style scoped>

.news-card {
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.5);
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
}

@media (min-width: 900px) {

.news-card {
    height: 20rem
}
  }

.news-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0)
    linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.7) 80%);
  z-index: 0;
}

.news-card__card-link {
    z-index: 1;
}

.news-card__image {
    transition: transform 3s ease;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    z-index: -1;
  }

.news-card__text-wrapper {
    transition: background-color 1.5s ease;
  }

.news-card__title {
    transition: color 1s ease;
  }

.news-card__details-wrapper {
    max-height: 0;
    opacity: 0;
    transition: max-height 1.5s ease, opacity 1s ease;
  }

@media (min-width: 900px) {
    .news-card:hover .news-card__details-wrapper {
      max-height: 20rem;
      opacity: 1;
    }
    .news-card .news-card__text-wrapper {
      background-color: rgba(31, 31, 31, 0.8);
    }
    .news-card:hover .news-card__image {
      transform: scale(1.2);
      z-index: -1;
    }
  }

.news-card__excerpt {
    font-weight: 300;
  }

</style>
